import { Controller } from 'stimulus';

class LoaderController extends Controller {
  connect() {
    this.hideLoaderInitially();

    window.addEventListener('load', () => {
      this.hideLoaderInitially();
    });

    // pageshow is triggered on both normal loads and navigating back cached loads
    // (back-foward cache). event.persisted is true if the page was loaded from the cache.
    // Source: https://web.dev/articles/bfcache
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) {
        this.hideLoaderInitially();
      }
    });
  }

  /**
   * In some instances the loader would still be visible when going back.
   * This function removes the is-open class to be sure.
   */
  hideLoaderInitially() {
    this.overlayTarget.classList.remove('is-open');
  }

  showLoader() {
    this.overlayTarget.classList.add('is-open');
  }
}

LoaderController.targets = [
  'overlay',
];

export default LoaderController;
